module.exports = __webpack_public_path__ + "media/images/iconSocialLink__inFrontOfAccent--dark-15949d6461c944f75f263b875716dbf1.png";